import eloBooksSymbol from 'assets/images/elo-books-symbol.svg';
import eloBooksDetailed from 'assets/images/elo-books-details-logo.svg';
import classes from './style.module.css';

type TitleProps = {
  collapsed: boolean;
};

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  return (
    <div className={!collapsed ? classes.logo : classes.logo_collapsed}>
      {collapsed ? (
        <img src={eloBooksSymbol} alt="elo-books" style={{ height: '24px', width: 'auto' }} />
      ) : (
        <img src={eloBooksDetailed} alt="elo-books" style={{ height: '32px', width: 'auto' }} />
      )}
    </div>
  );
};
